import { render, staticRenderFns } from "./PresubMultiConsentComponent.vue?vue&type=template&id=6bd4dda3"
import script from "./PresubMultiConsentComponent.vue?vue&type=script&lang=ts"
export * from "./PresubMultiConsentComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports